module.exports = __webpack_public_path__ + "static/media/sort_icon_asc.7974271c.svg";